import { render, staticRenderFns } from "./QuestionReport.Table.AgreeRate.vue?vue&type=template&id=510852d5&scoped=true&"
import script from "./QuestionReport.Table.AgreeRate.vue?vue&type=script&lang=js&"
export * from "./QuestionReport.Table.AgreeRate.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReport.Table.AgreeRate.vue?vue&type=style&index=0&id=510852d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510852d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
